import React from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
import backgroundImage from '../assets/background.jpg';


const DefaultLayout = () => {
  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div
        //  style={{backgroundImage: `url(${backgroundImage})`}}
          className="body flex-grow-1 px-3">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default DefaultLayout
